import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "objectFitPolyfill";
import "whatwg-fetch";

import store from "./store";

import "./styles/main.scss";

/*
	- Look for react modules on page. (Done)
	- Take the data set and add to module props. (Done)
	- Take data-component and mount. (Done)
	- Bootstrap module to element found on page. (Done)
	- Hook up to Redux, have modules talk to each other. (Done)
	- Talk to redux from a non-react module (Done)
	- Update dependencies. (Done)
	- Integrate existing frontend boilerplate code for scss etc. (Done)
	- Incorporate selectors (Done)
	- Create default Redux state based on data from backend. (Done)

	- Look at ways to mount modals calling mountReactComponents()
	- Pull in Reselect https://github.com/reduxjs/reselect (Needed?)

	Selectors prefix = get, is
	Actions prefix = set, do
*/
function mountReactComponents() {
    const components = Array.from(document.querySelectorAll(".react-module"));

    components.forEach((component) => {
        let data = {};
        const dataEl = component.querySelector(".react-module__data");

        let { component: componentName } = component.dataset;
        let componentDir = `${componentName}/${componentName}`;

        if (componentName.indexOf("base-modules/") === 0) {
            componentName = componentName.replace("base-modules/", "");
            componentDir = `base-modules/${componentName}/${componentName}`;
        }

        if (dataEl) {
            data = JSON.parse(dataEl.innerHTML);
        }

        import(`./modules/${componentDir}`)
            .then((response) => {
                return response.default;
            })
            .then((ReactModule) => {
                const module = (
                    <Provider store={store}>
                        <ReactModule data={data} {...component.dataset} />
                    </Provider>
                );

                ReactDOM.render(module, component);
            });
    });
}

function mountVanillaComponents() {
    const components = Array.from(document.querySelectorAll(".vanilla-module"));

    components.forEach((component) => {
        let { component: componentName } = component.dataset;
        let componentDir = `${componentName}/${componentName}`;

        if (componentName) {
            if (componentName.indexOf("base-modules/") === 0) {
                componentName = componentName.replace("base-modules/", "");
                componentDir = `base-modules/${componentName}/${componentName}`;
            }

            import(`./modules/${componentDir}`)
                .then((response) => {
                    return response.default;
                })
                .then((Module) => {
                    const config = {
                        props: { ...component.dataset },
                        root: component,
                        store,
                    };

                    const module = new Module(config);
                    module.init();
                });
        }
    });
}

function init() {
    mountReactComponents();
    mountVanillaComponents();
}

document.addEventListener("DOMContentLoaded", init);
